<template>
  <div>
    <header-game :close="false" :back="true"></header-game>
    <div class="container">
      <div class="home teams">
        <div class="ticketera">
          <div class="ticketera__title">
            <h3>{{$t('ticketera.title')}}</h3>
          </div>
          <div class="ticketera__content">
            <div class="form-group">
              <input type="text"
              ref="inputCode"
              v-model.trim="$v.ticketModel.number.$model"
              :class="{'has-error': $v.ticketModel.number.$error && $v.ticketModel.number.$invalid, 'with-value': $v.ticketModel.number.$model != ''}"
              :id="$t('ticketera.form.number')" class="form-control" required>
              <label class="form-control-placeholder" :for="$t('ticketera.form.number')">{{$t('ticketera.form.number')}}</label>
              <button class="button-paste" @click="pasteCode()">
                <img src="@/assets/paste.svg" alt="paste">
              </button>
            </div>
          </div>
          <button class="button button--white" :disabled="$v.ticketModel.number.$invalid || submitted" @click="goToNextStep()">
            {{submitted ? $t("ticketera.loading") : $t("ticketera.next")}}
          </button>
          <small>{{$t('ticketera.buyTickets')}} 
            <a v-if="selectGame.localTicketBuyLink != ''" href="javascript:;" @click="openLink(selectGame.localTicketBuyLink)">{{ selectGame.teamLocal.name }}</a> -
            <a v-if="selectGame.visitorTicketBuyLink != ''" href="javascript:;" @click="openLink(selectGame.visitorTicketBuyLink)">{{ selectGame.teamVisitor.name }}</a>
          </small>
        </div>
      </div>
    </div>
    <footer-sponsor></footer-sponsor>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import HeaderGame from '@/components/Header/Game.vue'
import FooterSponsor from '@/components/Footer/Sponsor.vue'
import PersistentData from '@/plugins/persistentData'

export default {
  components: {
    HeaderGame,
    FooterSponsor
  },
  data() {
    return {
      ticketModel: {
        number: ''
      },
      submitted: false
    }
  },
  computed: {
    ...mapState({
      selectGame: state => state.InfoModule.selectGame
    })
  },
  mounted() {
    if (Object.keys(this.selectGame).length === 0) {
      this.$store.dispatch('getGame', { id: this.$route.params.id })
    }

    console.log(this.selectGame)
  },
  methods: {
    async goToNextStep () {
      this.submitted = true;
      const model = {
        gameId: this.$route.params.id,
        code: this.ticketModel.number
      }
      const registerTicket = await this.$store.dispatch('registerTicket', model)
      if (registerTicket && registerTicket.status == 200) {
        PersistentData.setData('token', registerTicket.data.token)
        const teamId = registerTicket.data.teamId
        if (teamId) {
          this.$store.dispatch('getAvatars', { id: teamId })
          this.$router.push(`/game/${model.gameId}/${teamId}/avatar`)
        } else {
          this.$router.push(`/game/${model.gameId}/team`)
        }
      } else {
        this.$store.dispatch('addNotification', {
          value: this.$t('notifications.invalidCode'),
          status: "error",
          remove: true
        })
      }
      setTimeout(() => {
        this.submitted = false;
      }, 1000)
    },
    async pasteCode() {
      this.$refs.inputCode.focus();
      if (window["cordova"] != undefined) {
        window["cordova"].plugins.clipboard.paste(function (text) { 
          this.ticketModel.number = text
        });
      } else {
        const text = await navigator.clipboard.readText();
        this.ticketModel.number = text
      }
    },
    openLink(link) {
      window.open(link, '_system');
    }
  },
  validations: {
    ticketModel: {
      number: {
        required
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.ticketera {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 80px 0;

  .button {
    margin-top: $margin-base;
  }

  small {
    color: $white;
    max-width: 300px;
    text-align: center;
    margin-top: $margin-giga;

    a {
      text-decoration: underline;
    }
  }

  &__title {
    text-align: center;

    h3 {
      margin: 0;
      color: $white;
      font-weight: 700;
      @include font-settings(kilo, base);
    }
  }

  &__content {
    display: flex;
    justify-content: space-evenly;
    margin: $margin-mega 0 0;
    align-items: flex-start;
    width: 100%;
    max-width: 480px;
  }

  .button-paste {
    position: absolute;
    right: $margin-kilo;
    top: $margin-kilo;
    color: white;
    height: 20px;
  }
}
</style>